import { Icons } from '@cast/design-system';

type SidebarItemCaretProps = {
  expanded: boolean;
};

export const SidebarItemCaret = ({ expanded }: SidebarItemCaretProps) => {
  const Icon = expanded ? Icons.CaretUp : Icons.CaretDown;

  return <Icon size={16} weight="regular" color="currentColor" />;
};
